import { CanActivateFn, Router } from '@angular/router';
import { LoginServices } from '../auth/login/services/login.service'; 
import { inject } from '@angular/core';

export const loggedOutGuard: CanActivateFn = (route, state) => {
    const authService = inject(LoginServices); 
    const isValid = authService.isValid;

    return !isValid
    
};
